module.exports = __webpack_public_path__ + "static/media/altassd-logo.6d4590a1.png";